export const versionDate = '2026/03/20'; // YYYY/MM/DD
